<template>
    <portal to="modals" v-if="shouldShowModal">
        <b-modal
            v-model="shouldShowModal"
            size="lg"
            hide-footer
        >
            <document-form :id="file.id" @documentUpdated="documentUpdated"/>
        </b-modal>
    </portal>
</template>

<script>
    import DocumentForm from '~/components/forms/admin/document/form'
    import SuccessfullyUpdatedAlert from "~/Swals/SuccessfullyUpdatedAlert";

    export default {
        name: "documentEditModal",
        components: { DocumentForm },
        props: {
            showModal: {
                type: Boolean,
                default: false
            },
            file: {
                type: Object,
                required: true,
            }
        },
        methods: {
            async documentUpdated() {
                this.shouldShowModal = false

                new SuccessfullyUpdatedAlert({ entity: this.lang('app.file') }).show()

                this.$emit('updateSuccess')
            },
        },
        computed: {
            shouldShowModal: {
                get() {
                    return this.showModal
                },
                set(val) {
                    this.$emit('update:show-modal', val)
                }
            }
        },
    }
</script>
